import { getBathroomCount as T } from "@propify-tenant-client/common";
import { isSDK as a, api as o, ListingStatus as i, SHORT_DATE_FORMAT as N } from "@propify-tenant-client/services";
import k from "moment/moment";
const B = (t, e = !1) => t === void 0 || t.dogsAllowed && t.catsAllowed ? e ? "Pets" : "Dogs/Cats" : t.dogsAllowed ? "Dogs" : t.catsAllowed ? "Cats" : "No Pets", D = (t) => {
  const e = `/unit-applications/unit/${t.id}/create`;
  return a() ? t.residentPortalToken ? o.BASE_URL + e + `?token=${t.residentPortalToken}` : o.BASE_URL + e : e;
}, E = (t) => {
  const e = `/showings/schedule?unitId=${t.id}`;
  return a() ? t.residentPortalToken ? o.BASE_URL + e + `&token=${t.residentPortalToken}` : o.BASE_URL + e : e;
}, U = (t) => t.listingStatus === i.ACTIVE ? "Available now" : [i.COMING_SOON, i.HOLD].includes(t.listingStatus) ? `Available: ${k(t.readyDate).format(N)}` : "", _ = ({ state: t, displayRent: e, bedroomCount: n, bathroomCount: s, availableNow: m } = {}) => (r) => {
  const c = T(r), l = r.property.address.state, u = t ? l === t : !0, g = (e != null && e.min ? r.listedRent && Number(r.listedRent) >= Number(e.min) : !0) && (e != null && e.max ? r.listedRent && Number(r.listedRent) <= Number(e.max) : !0), A = n != null && n.min ? r.bedroomCount >= Number(n.min) : !0, S = s != null && s.min ? c >= Number(s.min) : !0, f = m ? r.listingStatus === i.ACTIVE : !0;
  return u && g && A && S && f;
};
export {
  D as getApplyNowLink,
  B as getPetPolicyText,
  _ as getUnitFilter,
  E as getUnitShowingLink,
  U as getUnitStatusLabel
};
//# sourceMappingURL=utils.js.map
